/* eslint-disable react/no-unused-state */
import React from 'react';
import PropTypes from 'prop-types';

import { requireImage } from '@nubank/www-latam-commons/utils/requireImage';

import { ResponsiveImageSizeContent, ImageContainer } from './style';

function ImageElement(props) {
  const {
    alt,
    background,
    title,
    imageStyle,
    parentImageStyle,
    children,
    height,
    width,
    path,
    extension,
    loading,
  } = props;

  if (!background) {
    return (
      <picture>
        <source type="image/webp" srcSet={requireImage(path, 'webp')} />

        <img
          alt={alt}
          title={title}
          src={requireImage(path)}
          style={imageStyle || parentImageStyle}
          width={width}
          height={height}
          type={`image/${extension}`}
          loading={loading}
        />
      </picture>
    );
  }
  const style = imageStyle || parentImageStyle || {};

  return (
    <ResponsiveImageSizeContent path={path} style={style}>
      {children}
    </ResponsiveImageSizeContent>
  );
}

function ResponsiveImageSize(props) {
  const { position } = props;
  const className = 'component-responsive-image-size';

  return (
    <ImageContainer className={className} position={position}>
      <ImageElement {...props} />
    </ImageContainer>
  );
}

const propTypes = {
  alt: PropTypes.string,
  background: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  extension: PropTypes.string.isRequired,
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  imageStyle: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
  loading: PropTypes.string,
  parentImageStyle: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
  path: PropTypes.string.isRequired,
  title: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

const defaultProps = {
  alt: '',
  background: false,
  children: {},
  imageStyle: {},
  parentImageStyle: {},
  title: '',
  height: undefined,
  width: undefined,
  loading: undefined,
};

ResponsiveImageSize.propTypes = {
  position: PropTypes.string,
  ...propTypes,
};
ImageElement.propTypes = propTypes;

ResponsiveImageSize.defaultProps = {
  position: 'center',
  ...defaultProps,
};

ImageElement.defaultProps = defaultProps;

export default ResponsiveImageSize;
